import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ganttastic from '@infectoone/vue-ganttastic'
import './index.css';
import store from './store';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import axios from "axios";

import L from "leaflet";

// Fix default icon URLs
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: new URL("leaflet/dist/images/marker-icon-2x.png", import.meta.url).href,
  iconUrl: new URL("leaflet/dist/images/marker-icon.png", import.meta.url).href,
  shadowUrl: new URL("leaflet/dist/images/marker-shadow.png", import.meta.url).href,
});


router.afterEach((to) => {
  // --- Background logic ---
  if (to.meta && to.meta.bgImage) {
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundSize = "cover";
    document.body.style.overflowX = "hidden";
    document.body.style.height = "100%";
    document.body.style.backgroundImage = `url(${to.meta.bgImage})`;
  } else {
    document.body.style.backgroundRepeat = "";
    document.body.style.backgroundPosition = "";
    document.body.style.backgroundImage = "";
  }

  // --- Visitor Tracking ---
  if (!localStorage.getItem("visitor_id")) {
    localStorage.setItem("visitor_id", crypto.randomUUID());
  }
  
  axios.post("https://aghub.miphost.com/api/track", {
    visitorId: localStorage.getItem("visitor_id"),
    page:  truncatePath(to.fullPath, 200),
    timestamp: Date.now(),
    referrer: document.referrer || null,
  }).catch(err => {
    console.error("Tracking failed:", err);
  });
});

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import 'bootstrap-icons/font/bootstrap-icons.css'

function truncatePath(path, maxLength = 200) {
  if (!path) return "";
  if (path.length <= maxLength) return path;

  // keep start and end for context
  const start = path.slice(0, 100);
  const end = path.slice(-50);
  return `${start}...${end}`;
}

const app = createApp(App)
app.use(router)
app.use(ganttastic)
app.use(store)
app.component('VueDatePicker', VueDatePicker);
app.mount('#app')
